import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/custom/ClientProviders.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Plus_Jakarta_Sans\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"plusJakarta\"}");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
